export type TattooBookingAuthPlacement = 'start' | 'before_upload' | 'before_summary';

export type TattooWizardStep =
  | 'shop'
  | 'service'
  | 'practitioner'
  | 'project'
  | 'customer'
  | 'slot'
  | 'summary'
  | 'payment'
  | 'success';

/** Shop step also collects the service (merged UI). */
const BASE_TATTOO_STEPS: TattooWizardStep[] = [
  'shop',
  'practitioner',
  'project',
  'slot',
  'summary',
];

const BASE_CONSULTATION_STEPS: TattooWizardStep[] = [
  'shop',
  'practitioner',
  'slot',
  'summary',
];

export function normalizeAuthPlacement(value: unknown): TattooBookingAuthPlacement {
  if (value === 'start' || value === 'before_upload' || value === 'before_summary') {
    return value;
  }
  return 'before_summary';
}

/**
 * Insert the customer (login/account) step at the configured placement.
 * Project step already includes optional reference images (merged).
 * Shop step includes service selection (merged).
 */
export function buildTattooBookingSteps(
  isConsultation: boolean,
  placement: TattooBookingAuthPlacement,
): TattooWizardStep[] {
  const steps = [...(isConsultation ? BASE_CONSULTATION_STEPS : BASE_TATTOO_STEPS)];

  let insertAt = 0;
  if (placement === 'start') {
    insertAt = 0;
  } else if (placement === 'before_upload') {
    const projectIdx = steps.indexOf('project');
    insertAt = projectIdx >= 0 ? projectIdx : steps.indexOf('summary');
  } else {
    insertAt = steps.indexOf('summary');
  }

  if (insertAt < 0) insertAt = steps.length;
  steps.splice(insertAt, 0, 'customer');
  return steps;
}

/** Map legacy draft steps (e.g. images, service) onto the current wizard keys. */
export function normalizeWizardStep(
  step: string | undefined,
  activeSteps: TattooWizardStep[],
  fallback: TattooWizardStep,
): TattooWizardStep {
  if (!step) return fallback;
  if (step === 'images') return activeSteps.includes('project') ? 'project' : fallback;
  if (step === 'service') return activeSteps.includes('shop') ? 'shop' : fallback;
  if (activeSteps.includes(step as TattooWizardStep)) return step as TattooWizardStep;
  return fallback;
}
